module.exports = __webpack_public_path__ + "img/id-4-768x510.9363df08.png";